import { GtmEventAction } from "@obg/gtm.types/adaptive";
import { CoreUiInteractionEvent, generateTrackingKey } from "@obg/ngx.core";
import { TrackingContext as NgxTrackingContext } from "@obg/ngx.ui.core";

import { TrackingContext, VerificationAction } from "./tracking.model";

export const CORE_UI_INTERACTION_TRACKING_MAP: Record<string, any> = {
	[generateTrackingKey(TrackingContext.MainNavigationInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "MainNavigationClick",
		waitForNavigation: true,
	},
	[generateTrackingKey(TrackingContext.LanguageSelectorInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "TopNavigationClick",
	},
	[generateTrackingKey(TrackingContext.MyAccountInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "MyAccountClick",
	},
	[generateTrackingKey(TrackingContext.ToolbarInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "TopNavigationClick",
	},
	[generateTrackingKey(NgxTrackingContext.ResetPasswordInteractionContext, GtmEventAction.LoginPasswordFormSubmit)]: {
		event: GtmEventAction.LoginPasswordFormSubmit,
	},
	[generateTrackingKey(NgxTrackingContext.ResetPasswordInteractionContext, GtmEventAction.ForgottenPasswordSuccess)]:
		{
			event: GtmEventAction.ForgottenPasswordSuccess,
		},
	[generateTrackingKey(TrackingContext.VerificationInteractionContext, VerificationAction.VerifyAccountOpen)]: {
		event: "VerifyAccountOpen",
	},
	[generateTrackingKey(TrackingContext.VerificationInteractionContext, VerificationAction.VerifyAccountClick)]: {
		event: "VerifyAccountClick",
	},
	[generateTrackingKey(TrackingContext.VerificationInteractionContext, GtmEventAction.AccountVerificationConfirmed)]:
		{
			event: GtmEventAction.AccountVerificationConfirmed,
		},
	[generateTrackingKey(TrackingContext.VerificationInteractionContext, GtmEventAction.VerificationBarShown)]: {
		event: GtmEventAction.VerificationBarShown,
	},
	[generateTrackingKey(TrackingContext.VerificationInteractionContext, GtmEventAction.VerificationStartClick)]: {
		event: GtmEventAction.VerificationStartClick,
	},
};
